import styled from 'styled-components';

// Container alinhado a esquerda, com altura proporcional ao card que o
// abriga (usado tanto inline em screens quanto dentro de Card wrappers).
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 10px 18px;
  box-sizing: border-box;
  gap: 4px;

  @media (max-width: 1250px) {
    padding: 8px 12px;
  }
`;

// BackArrow agora e um botao retangular arredondado (10px) com ghost-fill,
// em vez do circulo simples. Tamanho 34x34 da mais area de clique
// (recomendado WCAG ~44 — esta intermediario por densidade visual). O
// hover preenche com lightblue + lift sutil. Box-shadow no focus pra
// acessibilidade por teclado.
export const BackArrow = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.03)'
      : 'rgba(255, 255, 255, 0.04)'};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  border-radius: 6px;
  width: 34px;
  height: 34px;
  margin-right: 10px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.label};
  font-size: 18px;
  font-weight: 700;
  transition: background 150ms ease, color 150ms ease,
    border-color 150ms ease, transform 150ms ease;
  padding: 0;
  line-height: 1;
  font-family: inherit;
  flex-shrink: 0;

  :hover {
    background: ${(props) => props.theme.colors.lightblue};
    color: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.lightblue};
    transform: translateX(-1px);
  }

  :focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.lightblue};
    outline-offset: 2px;
  }

  :active {
    transform: translateX(-1px) scale(0.96);
  }

  @media (max-width: 1250px) {
    width: 30px;
    height: 30px;
    font-size: 16px;
    margin-right: 6px;
  }
`;

// Path — cada nivel da trilha. Clicaveis viram pill com hover sutil;
// o ultimo (current page) ganha pill com fundo da brand sem hover.
//
// O <span> filho e a chevron separadora — fica fora do pill, alinhada
// com a label em altura mas sem o hover effect.
export const Path = styled.label`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.lightblue};
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease;
  padding: 6px 10px;
  border-radius: 6px;

  :hover {
    background: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(59, 191, 241, 0.10)'
        : 'rgba(59, 191, 241, 0.16)'};
  }

  /* Chevron entre niveis — SVG inline em cor neutra. Margem negativa a
     direita encaixa o chevron mais proximo do proximo pill, mantendo o
     hover do pill atual isolado dentro do padding. */
  > span {
    display: inline-flex;
    align-items: center;
    margin: 0 -4px 0 8px;
    padding: 0 4px;
    color: ${(props) => props.theme.colors.label};
    cursor: default;
    opacity: 0.55;
    pointer-events: none;
  }

  /* Current page (ultimo path) — pill sutil colorido + bold, sem hover */
  :last-child {
    color: ${(props) =>
      props.theme.title === 'light'
        ? props.theme.colors.darkerblue
        : props.theme.colors.white};
    font-weight: 700;
    cursor: default;
    background: ${(props) =>
      props.theme.title === 'light'
        ? 'rgba(25, 43, 128, 0.08)'
        : 'rgba(255, 255, 255, 0.07)'};

    :hover {
      background: ${(props) =>
        props.theme.title === 'light'
          ? 'rgba(25, 43, 128, 0.08)'
          : 'rgba(255, 255, 255, 0.07)'};
    }
  }

  @media (max-width: 1250px) {
    font-size: 12px;
    padding: 4px 8px;

    > span {
      margin: 0 -4px 0 6px;
    }
  }
`;
